import React from "react";
import DailyDashboard from "./DailyDashboard";
import WeeklyDashboard from "./WeeklyDashboard";
import AllDashboard from "./AllDashboard";
import MonthlyDashboard from "./MonthlyDashboard";
import DashboardStore from "./stores/DashboardStore";
import HeaderDashboard from "./HeaderDashboard";
import DashboardActions from "./actions/DashboardActions";
import { parseISO } from "date-fns";

class Dashboard extends React.Component {
  constructor(props) {
    super(props)
    this.state = this.getStateFromStores();
    this._onChange = this._onChange.bind(this);
  }

  componentDidMount() {
    DashboardStore.addChangeListener(this._onChange);
    DashboardActions.init(this.props);

    if (this.props.home_show && this.props.currentDate) {
      this.setState({
        afterMount: true,
      });
    }
  }

  getStateFromStores() {
    return {
      activeTab: DashboardStore.getActiveTab(),
      currentDate: DashboardStore.getCurrentDate(),
      dateFormat: DashboardStore.getDateFormat(),
      dateData: DashboardStore.getDateData(),
      loading: DashboardStore.getLoading(),
      readOnly: DashboardStore.getReadOnly(),
      reservationSegments: DashboardStore.getReservationSegments(),
      reservationsUserRole: DashboardStore.getReservationsUserRole(),
      roomTypes: DashboardStore.getRoomTypes(),
      settingsUserRole: DashboardStore.getSettingsUserRole(),
      timeFormat: DashboardStore.getTimeFormat(),
      // daily_rentals: this.props.daily_rentals ? this.props.daily_rentals : false
    };
  }

  render() {
    var currentDate = this.state.currentDate;

    if (
      this.props.home_show &&
      this.props.currentDate &&
      !this.state.afterMount
    ) {
      currentDate = parseISO(this.props.currentDate);
    }

    return (
      <div className="dashboard" ref="container">
        <HeaderDashboard
          book_now_path={this.props.book_now_path}
          activeTab={this.state.activeTab}
          currentDate={currentDate}
          dateFormat={this.props.dateFormat}
          timeFormat={this.state.timeFormat}
          readOnly={this.state.readOnly}
        />
        <div className="row">
          <div className="col-md-12">
            {this.state.activeTab == "nightly" ? (
              <DailyDashboard
                path={this.props.daily_rentals_dashboard_path ? this.props.daily_rentals_dashboard_path : this.props.dashboard_check_in_check_out_path}
                currentDate={currentDate}
                dateFormat={this.state.dateFormat}
                timeFormat={this.state.timeFormat}
                readOnly={this.state.readOnly}
              />
            ) : null}
            {this.state.activeTab == "weekly" ? (
              <WeeklyDashboard
                path={this.props.dashboard_calendar_path}
                dateData={this.state.dateData}
                roomTypes={this.state.roomTypes}
                reservationSegments={this.state.reservationSegments}
                currentDate={currentDate}
                dateFormat={this.state.dateFormat}
                timeFormat={this.state.timeFormat}
                readOnly={this.state.readOnly}
              />
            ) : null}
            {this.state.activeTab == "monthly" ? (
              <MonthlyDashboard
                currentDate={currentDate}
                dateData={this.state.dateData}
                roomTypes={this.state.roomTypes}
                reservationSegments={this.state.reservationSegments}
                dateFormat={this.state.dateFormat}
                timeFormat={this.state.timeFormat}
                readOnly={this.state.readOnly}
              />
            ) : null}

            {this.state.activeTab == "daily" ? (
              <WeeklyDashboard
                path={this.props.dashboard_calendar_path}
                dateData={this.state.dateData}
                roomTypes={this.state.roomTypes}
                reservationSegments={this.state.reservationSegments}
                currentDate={currentDate}
                dateFormat={this.state.dateFormat}
                timeFormat={this.state.timeFormat}
                readOnly={this.state.readOnly}
              />
            ): null}
            
            {this.state.activeTab == "all" ? (
              <AllDashboard
                path={this.props.dashboard_all_segments_data_table_path}
                dateFormat={this.state.dateFormat}
                timeFormat={this.state.timeFormat}
                readOnly={this.state.readOnly}
              />
            ) : null}
          </div>
        </div>
        {this.state.loading ? (
          <div className="loadingOverlay">
            <div className="spinner"></div>
          </div>
        ) : null}
      </div>
    );
  }

  _onChange() {
    this.setState(this.getStateFromStores());
  }
}

export default Dashboard;
